module.exports = __webpack_public_path__ + "img/onscreen-no-text.8da53e74.svg";